import {
  AItoolsmenu,
  productivityAndWellness,
} from "../../../constants/library";
import { Backtotop, Floatinmenu, Underline,AI_tools_part_two } from "../../../widgets";
import "../../Library/AI_bots.css";
import { RadialMenu } from "../../../components";
import { FaMicrochip } from "react-icons/fa";

export default function Productivity() {

    return (
        <>
      <div className="librarypage">
            <div className="librarybg">
                <div className="libraryheading">AI - Tools</div>
                <div className="library_sub_heading">Productivity and Wellness</div>
            </div>
        </div>
        <section className="librarydark">
            <div className="dept_float_menu">
                <Floatinmenu logo={FaMicrochip} head="Menu" links={AItoolsmenu} />
            </div>
            <RadialMenu menu_links={AItoolsmenu} />
            <Underline heading="Productivity and Wellness" />
            <div  style={{ display: 'flex', flexWrap: 'wrap' }}>
                 {productivityAndWellness.map((tool, index) => (
        <AI_tools_part_two key={index} {...tool} />
      ))}
            </div>
        </section>
        <Backtotop />

        </>
    )
}